import Datetime from 'react-datetime';

export function getFormattedDate(date) {
  const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);

  return `${day}.${month}.${date.getFullYear()}`;
};

export function toFormattedNumber(value) {
  return Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export function convertUTCToLocalDate(date) {
  if (!date) {
    return date;
  }

  date = Datetime.moment(date);

  date = new Date(
    date.year(), date.month(), date.date(),
    date.hour(), date.minute(), date.second()
  );

  return date;
};

export function convertLocalToUTCDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(
    date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds()
  );
  return date;
};

export function getColor(whiteLabel) {
  let colorCode = "";
  switch (whiteLabel) {
  case "t365":
    colorCode = "#25282a";
    break;
  case "pacificCapital":
    colorCode = "#2b637c";
    break;
  case "trustbucks":
    colorCode = "#263e0f";
    break;
  case "fxmb":
  case "88mids":
  case "starmids":
    colorCode = "#223679";
    break;
  default:
    colorCode = "#187EED";
  }
  return colorCode;
};

export function addLogItem(logs, type, valueBefore, valueAfter, field, id, info) {
  const isLogGroupPresent = logs.find(e => e.id === id.toString() && e.type === type);
  // if log type is already there
  if (isLogGroupPresent) {
    logs.forEach((logGroup, index) => {
      const isParameterPresent = logGroup.parameters.some(p => p.fieldName === field);
      if (isParameterPresent) {
        logGroup.parameters.forEach((log, i) => {
          if (log.fieldName === field) {
            if (log.valueBefore !== valueAfter && log.fieldName === field) {
              log = Object.assign(log, { valueAfter });
            } else {
              logGroup.parameters.splice(i, 1);
            }
          }
        });
      } else if (logGroup.id === id.toString() && logGroup.type === type) {
        logGroup.parameters.push({
          fieldName: field,
          valueBefore,
          valueAfter
        });
      }
    });
    
  } else {
    logs.push({
      id: id.toString(),
      type,
      info,
      parameters: [{
        valueBefore,
        valueAfter,
        fieldName: field
      }]
    });
  }

  return logs.filter(item => item.parameters.length !== 0);
};